module.exports = "/_next/static/images/f682d8cebc3d93a26cd88773a13649d9-debit-card-cut-lg.png.webp";